import React, { useEffect, useState } from "react";
import {
  FaArrowDown,
  FaComment,
  FaUserAlt,
  FaUserCircle,
} from "react-icons/fa";
import axios from "axios";
import { BACKEND } from "../../config/configEnvs";
import AnuncioComentario from "./AnuncioComentario";
import TruncatedText from "./TruncatedText";

import Moment from "react-moment";
import "moment/locale/es";
const AnuncioCard = ({ anuncio, index, anuncios, setAnuncioModal }) => {
  const [comentarios, setComentarios] = useState([]);
  const [page, setPage] = useState(1);

  const [activeComents, setActiveComments] = useState(false);
  const getComents = async () => {
    const responses = await axios.get(
      `${BACKEND}/api/anunciosComentarios?where[anuncio][equals]=${anuncio.id}&page=${page}`
    );
    setComentarios(responses.data.docs);
  };

  useEffect(() => {
    getComents();
  }, [page]);
  // Calcula la diferencia de tiempo
  const fechaCreacion = new Date(anuncio.createdAt);
  const fechaActual = new Date();
  const diferenciaTiempo = fechaActual - fechaCreacion;
  const segundosTranscurridos = Math.floor(diferenciaTiempo / 1000);
  const minutosTranscurridos = Math.floor(segundosTranscurridos / 60);
  const horasTranscurridas = Math.floor(minutosTranscurridos / 60);
  const diasTranscurridos = Math.floor(horasTranscurridas / 24);

  // Genera el texto para mostrar el tiempo transcurrido
  let tiempoTranscurridoTexto;
  if (diasTranscurridos > 0) {
    tiempoTranscurridoTexto = `Hace ${diasTranscurridos} día(s)`;
  } else if (horasTranscurridas > 0) {
    tiempoTranscurridoTexto = `Hace ${horasTranscurridas} hora(s)`;
  } else if (minutosTranscurridos > 0) {
    tiempoTranscurridoTexto = `Hace ${minutosTranscurridos} minuto(s)`;
  } else {
    tiempoTranscurridoTexto = `Hace unos segundos`;
  }

  return (
    <div key={anuncio.id} className=" pb-10 w-full relative">
      <div className="flex items-center py-4 space-x-4">
        {anuncio?.autor?.foto ? (
          <img
            width={200}
            height={200}
            className="w-9 h-9 rounded-full"
            src={anuncio?.autor?.foto?.url}
            alt={anuncio?.autor?.name}
          />
        ) : (
          <FaUserCircle className=" w-9 h-9" />
        )}
        <div className="grid grid-rows-2">
          <span className="font-medium text-sm  text-gray-800">
            {anuncio?.autor?.name}
          </span>
          <span className="text-xs text-zinc-600">
            <Moment className=" capitalize   not-italic" fromNow>
              {anuncio?.createdAt}
            </Moment>{" "}
          </span>
        </div>
      </div>

      <div className=" pb-2">
        <span className=" text-gray-700 text-sm  font-semibold">{anuncio?.title}</span>
      </div>
      <div>
        <TruncatedText
          setAnuncioModal={setAnuncioModal}
          anuncio={anuncio}
          text={anuncio.descripcion}
          maxLines={5}
        />

        {/* {anuncio?.imagen && (
          <div className="flex mx-auto w-auto  max-h-48">
            <div className="flex mx-auto object-contain">
              <img
                className="mx-auto rounded-lg"
                src={anuncio.imagen.url}
                alt=""
              />
            </div>
          </div>
        )} */}
      </div>

      <div className=" pt-10 flex justify-center">
        <button
          className=" p-3  text-xs rounded-full flex justify-center gap-4 items-center hover:bg-opacity-20 bg-orange-600 bg-opacity-10 text-orange-700"
          type="button"
          onClick={() => setAnuncioModal({ active: true, anuncio: anuncio })}
        >
          <FaComment />
          <span> Comentarios ({comentarios.length})</span>
        </button>
      </div>

      {activeComents && (
        <div className=" flex flex-col gap-4 px-14 w-full absolute left-0 bottom-0 bg-transparent   ">
          <div className=" px-4 pt-4 pb-8 shadow-lg bg-white">
            <div className=" flex justify-center pb-4">
              <button>
                <FaArrowDown onClick={() => setActiveComments(false)} />
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AnuncioCard;
